import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Snackbar,
  Alert,
} from '@mui/material';
import { setAlertDescription, setAlertDescriptionOpen, useActionAlertState } from '../../../hooks/actions';

interface CUSTOMS_COLORS_ALERT {
  success: string;
  info: string;
  error: string;
  warning: string;
}

const CUSTOM_COLORS_ALERT: CUSTOMS_COLORS_ALERT = {
  success: '#388E3D',
  info: '#037DCB',
  error: '#CD2929',
  warning: '#F37100',
}

const ErrorSnackBar = () => {
  const [open, setOpen] = useState(false);
  const alertDescription = useActionAlertState().alertDescription.get();
  const str = alertDescription?.severity as string

  useEffect(() => {
    if (alertDescription?.open) {
      handleClick();
    }
  }, [alertDescription])

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertDescriptionOpen(false);
    setOpen(false);
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={10000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={alertDescription?.severity}
        sx={{
          width: '100%',
          backgroundColor: CUSTOM_COLORS_ALERT[str as keyof CUSTOMS_COLORS_ALERT],
          color: '#FFFFFF',
          '& .MuiAlert-icon': {
            color: '#FFFFFF',
          }
        }}
      >
        {alertDescription?.message}
      </Alert>
    </Snackbar>
  );
}

export default ErrorSnackBar;
